import { useEffect, useState } from 'react';

// iOS는 사용자 탭과 동일한 실행 컨텍스트에서 navigator.share를 호출해야 NotAllowedError가 나지 않는다.
// 그래서 파일을 미리 받아두고, 탭 시점에는 공유만 수행한다.
export const useShareableFile = (url, fileName) => {
  const [file, setFile] = useState(null);

  useEffect(() => {
    if (!url || !navigator.canShare) return undefined;

    let cancelled = false;

    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        if (cancelled) return;
        const fetched = new File([blob], fileName, { type: blob.type });
        if (navigator.canShare({ files: [fetched] })) setFile(fetched);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [url, fileName]);

  return file;
};
